<div id="setting-savefile-merge">
    <h2 class="title">Existing savefile detected</h3>
    <span class="description">
        <p><b>Existing save data</b> has been detected in your local browser storage.</p>
        <p>Do you want to <b>merge</b> this save data into the save data for <b>$username</b>?</p>
        <p><small>You will retain both your local progress and your account progress. If the state of the same nonogram differs between your local savefile and the account savefile, the local state will <i>overwrite</i> the state in the account.</small></p>
    </span>
    <button id="btn-savefile-merge">Merge local savefile into my account</button>
</div>